import * as couponActivityList from '../services/couponActivityList';

export default {
  namespace: 'activityCouponList',
  state: {},
  effects: {
    //优惠券活动列表
    *getActivityList({ payload: { values }, callback }, { call, put }) {
      //日期需要拼上时间
      let { beginDateTime, endDateTime, ...restParam } = values;
      if (beginDateTime) {
        beginDateTime = `${beginDateTime} 00:00:00`;
      }
      if (endDateTime) {
        endDateTime = `${endDateTime} 23:59:59`;
      }
      const response = yield call(couponActivityList.getActivityList, {
        ...restParam,
        beginDateTime,
        endDateTime,
      });
      yield put({
        type: 'save',
        payload: {
          activityList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //删除
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(couponActivityList.activityDelete, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //审核
    *activityApprove({ payload: { values }, callback }, { call }) {
      const response = yield call(couponActivityList.activityApprove, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //审核
    *activityPause({ payload: { values }, callback }, { call }) {
      const response = yield call(couponActivityList.activityPause, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
